import {
  SadaContent,
  SadaLayout,
  SadaScroll,
  SadaSider,
  SadaSiderBackdrop,
} from './styles';
import { useRoutes } from 'hookrouter';
import routesConfig from '../../constants/routes.config';
import NotFound from '@components/not-found';
import * as R from 'ramda';
import Header from './header';
import InviteEmployeeModal from '@components/modals/invite-employee-modal';
import Menu from '@components/menu';
import OrgCard from '@components/cards/org-card';
import { type IOrganization } from '@types/organization.type';
import useData from '@hooks/data.hook';
import { AnimatePresence } from 'framer-motion';
import { SlideIn } from '@components/ui/animations';
import ApplicantModal from '@components/modals/applicant-modal';
import CaseModal from '@components/modals/case-modal';
import AppointmentModal from '@components/modals/appointment-modal';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CaseManagerModal from '@components/modals/case-manager-modal';
import CaseStatusModal from '@components/modals/case-status-modal';
import useRoute from '@hooks/route.hook';
import UserProfileDialog from '@components/modals/user-profile-dialog';
import { useStore } from 'react-context-hook';
import EditAppointmentModal from '@components/modals/edit-appointment-modal';
import ApplicatonAnswersModal from '@components/modals/applicaton-answers-modal';
import CommentModal from '@components/modals/comment-modal';

const router = R.map(({ component: Component }) => (props) => (
  <Component {...props} key={Component.name} />
))(routesConfig);

const Layout = () => {
  const component = useRoutes(router);
  const current = useRoute(routesConfig);
  const [menu, setMenu] = useStore('menu', false);
  const [org, loading]: [IOrganization] = useData('organization', 'primary');
  return (
    <SadaLayout menu={menu}>
      <SadaSiderBackdrop
        onClick={() => {
          setMenu(false);
        }}
      />
      <SadaSider menu={menu}>
        <Menu
          routes={routesConfig}
          footer={<OrgCard editable {...org} loading={loading} />}
        />
      </SadaSider>
      <SadaContent>
        <Header />
        {component ? (
          <SadaScroll component={component} full={current?.full}>
            <AnimatePresence exitBeforeEnter>
              <SlideIn key={component.key}>{component}</SlideIn>
            </AnimatePresence>
          </SadaScroll>
        ) : (
          <NotFound />
        )}
      </SadaContent>
      <InviteEmployeeModal />
      <ApplicantModal />
      <CaseModal />
      <AppointmentModal />
      <CaseManagerModal />
      <CaseStatusModal />
      <UserProfileDialog />
      <EditAppointmentModal />
      <ApplicatonAnswersModal />
      <CommentModal />
    </SadaLayout>
  );
};
export default Layout;
